'use strict';
//TODO: write a spec
const addPx = require('@mindmup/mapjs-core/src/util/px');
module.exports = function StoryboardDimensionProvider(storyboardFontSize, resourceManager) {
	if (!storyboardFontSize) {
		throw 'invalid-args';
	}
	const self = this,
		hasBullets = function (text) {
			const result = /\n-/.test(text);
			return result;
		};
	self.getDimensionsForScene = function (scene, width, height) {
		const padding = Math.floor(width / 16),
			result = {
				text: {
					'height': height - 2 * padding,
					'width': width - 2 * padding,
					'padding-top': padding,
					'padding-bottom': padding,
					'padding-left': padding,
					'padding-right': padding,
					toCss: function () {
						const css = {};
						Object.keys(result.text).forEach(key => {
							if (key !== 'text' && key !== 'toCss') {
								css[key] = addPx(result.text[key]);
							}
						});
						return css;
					}
				},
				image: {
					toCss: function () {
						return {
							'background-image': '',
							'background-repeat': '',
							'background-size': '',
							'background-position': ''
						};
					}
				}
			};
		let imageScale = 1, maxImageHeight = height, maxImageWidth = width, textDims = 0, additionalPadding = 0;

		if (scene.image) {
			if (scene.image.position === 'top' || scene.image.position === 'bottom') {
				maxImageHeight = height / 2 - padding;
				result.text['padding-' + scene.image.position] = height / 2;
				result.text.height = height / 2 - padding;
			} else if (scene.image.position === 'left' || scene.image.position  === 'right') {
				maxImageWidth = width / 2 - padding;
				result.text['padding-' + scene.image.position] = width / 2;
				result.text.width = width / 2 -  padding;
			}
			imageScale = maxImageWidth / scene.image.width;
			if (imageScale > maxImageHeight / scene.image.height) {
				imageScale = maxImageHeight / scene.image.height;
			}
			result.image = {
				'url': scene.image.url,
				'height': (imageScale * scene.image.height),
				'width': (imageScale * scene.image.width)
			};
			if (scene.image.position === 'top') {
				result.image.top =  0.25 * height - result.image.height * 0.5;
				result.image.left = (width - result.image.width) / 2;
			} else if (scene.image.position === 'bottom') {
				result.image.top =  0.75 * height - result.image.height * 0.5;
				result.image.left = (width - result.image.width) / 2;
			} else if (scene.image.position === 'left') {
				result.image.top = (height - result.image.height) / 2;
				result.image.left = (width / 2 - result.image.width) / 2;
			} else if (scene.image.position === 'right') {
				result.image.top = (height - result.image.height) / 2;
				result.image.left = 0.75 * width - result.image.width * 0.5;
			} else {
				result.image.top = (height - result.image.height) / 2;
				result.image.left = (width - result.image.width) / 2;
			}
			result.image.toCss = function () {
				const url = (resourceManager && resourceManager.getResource(scene.image.url)) || scene.image.url;
				return {
					'background-image': 'url("' + url + '")',
					'background-repeat': 'no-repeat',
					'background-size': addPx(imageScale * scene.image.width) + ' ' + addPx(imageScale * scene.image.height),
					'background-position': addPx(result.image.left) + ' ' + addPx(result.image.top)
				};
			};
		}
		if (hasBullets(scene.title)) {
			result.text['text-align'] = 'left';
		}
		textDims = storyboardFontSize(scene.title, result.text.width, result.text.height);
		result.text.fontSize = textDims.fontSize;
		result.text.lineHeight = textDims.lineHeight;
		additionalPadding = (result.text.width - textDims.textWidth) / 2;
		if (additionalPadding > 0) {
			result.text.width = textDims.textWidth;
			result.text['padding-left'] += additionalPadding;
			result.text['padding-right'] += additionalPadding;
		}
		return result;
	};

};
